import { render, staticRenderFns } from "./MissionVision.vue?vue&type=template&id=0a80cd31"
import script from "./MissionVision.vue?vue&type=script&lang=js"
export * from "./MissionVision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports